export default __webpack_public_path__ + "static/media/bg-cs-2.1096f82d.png";